import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from 'app/app.module';
import { environment } from 'environments/environment';
import { hmrBootstrap } from 'hmr';
import 'hammerjs';

(window as any).__BUILD_HASH__ = '{{POST_BUILD_ENTERS_HASH_HERE}}';

// Tealium (utag.js) is a marketing-managed tag container that is republished on tags.tiqcdn.com, so a pinned SRI hash
// would break on every publish. It is constrained by the Content-Security-Policy origin allowlist instead, and is loaded
// with src-only script elements (no inline script) so the policy does not need 'unsafe-inline' for it.
function loadScript(src: string, target: 'head' | 'body'): void {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.type = 'text/javascript';
    const targetElement = target === 'head' ? document.head : document.body;
    targetElement.appendChild(script);
}

function loadTealiumScripts(env: string): void {
    const tealiumBaseUrl = environment.feature.localUtag
        ? '/assets/js/utag'
        : `https://tags.tiqcdn.com/utag/ups/ups-capital/${ env }`;

    loadScript(`${ tealiumBaseUrl }/utag.sync.js`, 'head');

    // Tealium universal data object
    (window as any).utag_data = { link_name: '' };

    loadScript(`${ tealiumBaseUrl }/utag.js`, 'body');
}

const tagEnv = environment.production ? 'prod' : 'dev';
loadTealiumScripts(tagEnv);

if (environment.production) {
    enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

if (environment.hmr) {
    if (module['hot']) {
        hmrBootstrap(module, bootstrap);
    } else {
        console.error('HMR is not enabled for webpack-dev-server!');
        console.log('Are you using the --hmr flag for ng serve?');
    }
} else {
    bootstrap();
}
